import { useState } from "react";
import useNavLinks from "constant/HeaderLinks";
import { Link } from "react-router-dom";
import { X, CaretUp, CaretDown, LinkedinLogo } from "@phosphor-icons/react";
import { FacebookLogo, InstagramLogo, XLogo } from "@phosphor-icons/react";
import SwitchLanguage from "../SwitchLanguage/SwitchLanguage";
import { useTranslation } from "react-i18next";
const Drawer = ({ isActive, onHandleDrawer }) => {
  const navLinks = useNavLinks();
  const [openSubMenuIndex, setOpenSubMenuIndex] = useState(null);

  const toggleSubMenu = (index) => {
    setOpenSubMenuIndex((cur) => (cur === index ? null : index));
  };

  const { t } = useTranslation();

  return (
    <>
      <div
        className={`fixed right-0  top-0 bottom-0 w-[98vw] sm:w-[80vw] md:w-[46vw] lg:w-[38vw] xl:w-[26rem] h-[100vh] bg-[#231f20aa] z-[1000000] px-6 py-10 flex flex-col justify-between transition ease-in duration-300 ${
          isActive ? "translate-x-[0]" : "translate-x-[100%]"
        }`}
      >
        <div>
          <div className="flex flex-col gap-y-3 flex-col-reverse ss:flex-row items-center justify-between border-b border-white pb-2">
            {/* <img className="w-28" src={Logo} alt="" /> */}
            <button onClick={onHandleDrawer}>
              <X size={28} color={"white"} />
            </button>
          </div>
          <div>
            <ul className="flex flex-col gap-y-2 capitalize mt-14">
              {navLinks.map(({ name, path, menu, mega }, index) =>
                mega ? (
                  <button
                    key={index}
                    onClick={() => toggleSubMenu(index)}
                    className="border-b py-2 text-white font-medium"
                  >
                    <span className="flex items-center justify-between capitalize">
                      {name}
                      {openSubMenuIndex === index ? (
                        <CaretUp size={20} />
                      ) : (
                        <CaretDown size={20} />
                      )}
                    </span>

                    <ul
                      className={`${
                        openSubMenuIndex === index
                          ? "grid grid-cols-2 text-start justify-between w-full gap-3 items-start ml-4 my-4 text-sm capitalize list-disc"
                          : "hidden"
                      }`}
                    >
                      {menu?.map(({ slug, title }, subIndex) => (
                        <li key={subIndex}>
                          <Link
                            to={`/serviceDetailes/${slug}`}
                            onClick={onHandleDrawer}
                            className="text-white text-start hover:underline"
                          >
                            {title}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </button>
                ) : (
                  <Link
                    key={index}
                    className="border-b py-2 text-white font-medium"
                    to={path}
                    onClick={onHandleDrawer}
                  >
                    {name}
                  </Link>
                )
              )}
            </ul>
            <SwitchLanguage />
            <a
              href="mailto:solutions@iasco.sa"
              className="mt-6 block w-full bg-white text-black text-center py-3 px-6 rounded-lg font-semibold hover:bg-gray-200 transition-colors uppercase"
            >
              {t("nav_join_us")}
            </a>
          </div>
        </div>

        <div className="border-t border-white pb-8"></div>
      </div>
      <div
        onClick={onHandleDrawer}
        className={`fixed inset-0 w-[100vw] h-[100vh] bg-[#000000ce] transition ease-in duration-300 ${
          isActive
            ? "opacity-100  z-[10000] scale-1 select-auto visible"
            : "opacity-0 z-[-1] scale-[1.2] select-none invisible"
        }`}
      ></div>
    </>
  );
};

export default Drawer;
